export default __webpack_public_path__ + "static/media/no77Shark.8faadb65.png";